/**
 * Race-to-playstyle-archetype mapping for Blood Bowl races.
 * Used on the race selection page to display trait badges.
 */

export type RaceTrait = "Bashy" | "Agile" | "Balanced" | "Stunty" | "Resilient"

export const RACE_TRAITS: Record<string, RaceTrait[]> = {
  orc: ["Bashy", "Balanced"],
  human: ["Balanced"],
  skaven: ["Agile"],
  dwarf: ["Bashy", "Resilient"],
  dark_elf: ["Agile", "Bashy"],
  shambling_undead: ["Bashy", "Resilient"],
  wood_elf: ["Agile"],
  lizardmen: ["Bashy", "Agile"],
  chaos_chosen: ["Bashy"],
  goblin: ["Stunty"],
  nurgle: ["Bashy", "Resilient"],
  high_elf: ["Agile", "Balanced"],
  halfling: ["Stunty"],
  snotling: ["Stunty"],
  gnome: ["Stunty"],
  necromantic_horror: ["Bashy", "Resilient"],
  vampire: ["Agile", "Resilient"],
  tomb_kings: ["Bashy", "Resilient"],
  chaos_renegades: ["Bashy"],
  khorne: ["Bashy"],
  underworld_denizens: ["Stunty", "Bashy"],
  chaos_dwarf: ["Bashy", "Resilient"],
  imperial_nobility: ["Balanced"],
  bretonnian: ["Balanced"],
  old_world_alliance: ["Balanced"],
  elven_union: ["Agile"],
  ogre: ["Bashy", "Stunty"],
  amazon: ["Agile", "Balanced"],
  norse: ["Bashy", "Agile"],
  black_orc: ["Bashy"],
}

export function getRaceTraits(raceKey: string): RaceTrait[] {
  return RACE_TRAITS[raceKey] ?? ["Balanced"]
}
